export default [
  {
    path:'/test',
    component: () => import('@/views/test/test.vue'),
  }
]